
export const documentList = {
  noDocumentsLabel: {
    en: 'No documents',
    nb: 'Ingen dokumenter',
    nn: 'Ingen dokumenter',
  },
  offerLetter: {
    en: 'Offer letter',
    nb: 'Tilbudsbrev',
    nn: 'Tilbodsbrev',
  },
  rejectionLetter: {
    en: 'Rejection letter',
    nb: 'Avslagsbrev',
    nn: 'Avslagsbrev',
  },
  bankingInterestRateChangeLetter: {
    en: 'Interest rate change',
    nb: 'Renteendring',
    nn: 'Endring i renta'
  },
  backingGuaranteeApproval: {
    en: 'Backing guarantee offer letter',
    nb: 'Tilbudsbrev vekstgaranti',
    nn: 'Tilbodsbrev vekstgaranti',
  },
  backingGuaranteeRejection: {
    en: 'Backing guarantee rejection letter',
    nb: 'Avslagsbrev vekstgaranti',
    nn: 'Avslagsbrev vekstgaranti',
  },
  decision: {
    en: 'Decision',
    nb: 'Vedtak',
    nn: 'Vedtak',
  },
} as const;
